var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u30EC\\u30A4\\u30E4\\u30FC_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 256 256",
    style: {
      enableBackground: "new 0 0 256 256"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 1.7.22")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(128 128) scale(0.72 0.72)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-175.05 -175.05000000000004) scale(3.89 3.89)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.3,74.4c-0.4,0-0.9-0.2-1.2-0.5l-46.6-47c-0.7-0.7-0.6-1.7,0-2.4c0.7-0.7,1.7-0.6,2.4,0l46.6,47c0.7,0.7,0.6,1.7,0,2.4 C69.1,74.3,68.7,74.4,68.3,74.4z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 61.5,
    cy: 40.7,
    rx: 1.8,
    ry: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.3,67.4H26.2c-3.5,0-6.4-2.9-6.4-6.4V39.3c0-3.5,2.9-6.4,6.4-6.4h2.5c0.3,0,0.6-0.1,0.9-0.2c0.9-0.3,1.8,0.1,2.2,1 c0.3,0.9-0.1,1.8-1,2.2c-0.7,0.2-1.4,0.4-2.1,0.4h-2.5c-1.7,0-3,1.4-3,3V61c0,1.7,1.3,3,3,3h35.1c0.9,0,1.7,0.8,1.7,1.7 C63,66.6,62.2,67.4,61.3,67.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45,61.6c-6.8,0-12.2-5.5-12.2-12.3c0-3.3,1.3-6.4,3.6-8.7c0.7-0.7,1.7-0.7,2.4,0c0.7,0.7,0.7,1.7,0,2.4 c-1.7,1.7-2.6,4-2.6,6.4c0,5,4,9,8.9,9c2.4,0,4.6-0.9,6.3-2.6c0.7-0.7,1.7-0.7,2.4,0c0.7,0.7,0.7,1.7,0,2.4 C51.4,60.3,48.3,61.6,45,61.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.6,65.4c-0.3,0-0.7-0.1-1-0.3c-0.8-0.5-0.9-1.6-0.4-2.3c0.4-0.5,0.6-1.1,0.6-1.8V39.3c0-1.7-1.3-3-3-3h-2.5 c-2.2,0-4.3-1.2-5.3-3.2l-0.8-1.4c-0.7-1.2-1.9-2-3.3-2H38.1c-1.1,0-2.1,0.5-2.8,1.3c-0.6,0.7-1.7,0.8-2.4,0.2 c-0.7-0.6-0.8-1.7-0.2-2.4c1.4-1.6,3.3-2.5,5.4-2.5h13.7c2.6,0,5,1.5,6.3,3.8l0.8,1.4c0.5,0.9,1.4,1.4,2.3,1.4h2.5 c3.5,0,6.4,2.9,6.4,6.4V61c0,1.4-0.4,2.6-1.2,3.7C68.6,65.2,68.1,65.4,67.6,65.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.4,53c-0.1,0-0.2,0-0.3,0c-0.9-0.2-1.5-1.1-1.3-2c0.1-0.6,0.2-1.1,0.2-1.7c0-4.9-4-9-8.9-9c-0.6,0-1.2,0.1-1.8,0.2 c-0.9,0.2-1.8-0.4-2-1.3c-0.2-0.9,0.4-1.8,1.3-2c0.8-0.2,1.6-0.2,2.4-0.2c6.8,0,12.2,5.5,12.2,12.3c0,0.8-0.1,1.6-0.2,2.4 C56.9,52.4,56.2,53,55.4,53z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoImage);
export default __webpack_public_path__ + "static/media/no-image.07f5dad2e5d105c7b4e9bca07f485197.svg";
export { ForwardRef as ReactComponent };